<template>
	<div class="fullscreen-overlay">
		<close-btn @click="close"/>

		<div class="overlay-body text-centered">
			<div>
				<h2 class="overlay-header">SCAN TICKET</h2>

				<div class="scanCamera">
					<qrcode-stream @init="onInit" class="mb-3" @decode="onDecode">
						<div v-if="isLoadingCamera" class="">
							<h5>Loading Camera</h5>
							<LoadingDots/>
						</div>
					</qrcode-stream>
				</div>

				<div>
					<input id="scanInput" type="text" placeholder="Manual Entry" v-model="scanCode" class="manualInput"/>
					<button id="registerButton" v-on:click="scannedCode" :disabled="!scanCode" class="better-mobile-btn"><i class="fas fa-search"></i></button>
				</div>
			</div>

			<div class="p-1">
				<PurchaseTicket
					v-if="enablePurchaseTicket"
					class="p-1"
					@submit="purchase"
				/>

				<ScanReentryButton
					class="p-1"
					@scanned="scanForReentry"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import {QrcodeStream} from "vue-qrcode-reader";
import LoadingDots from "./icons_svg/LoadingDots.vue";
import ScanReentryButton from "./ScanReentryButton.vue";
import PurchaseTicket from "./PurchaseTicket.vue";
import CloseBtn from "@/components/CloseBtn.vue";

export default {
	name: 'AddUserPopup',
	components: {
		CloseBtn,
		QrcodeStream,
		LoadingDots,
		ScanReentryButton,
		PurchaseTicket,
	},
	props: {},
	data() {
		return {
			isLoadingCamera: false,
			showCamera: false,
			isScanning: false,
			awaitingScan: false,
			scanCode: "",
		}
	},
	computed: {
		enablePurchaseTicket() {
			return this.$scanner.availableTickets && this.$scanner.availableTickets.length > 0
		}
	},
	methods: {
		async onInit(promise) {
			this.isLoadingCamera = true;
			// eslint-disable-next-line no-empty
			try {
				await promise
				// eslint-disable-next-line no-empty
			} catch (error) {
				alert("failed to load camera")
			} finally {
				this.isLoadingCamera = false;
			}
		},
		onDecode(decodedString) {
			this.scanCode = decodedString;
			document.getElementById('scanInput').value = decodedString;
			this.scannedCode()
		},
		scanForReentry(rfid) {
			let scanCodeInputEl = document.getElementById('scanInput');
			scanCodeInputEl.value = rfid;
			this.scanCode = rfid;
			this.scannedCode();
		},
		scannedCode() {
			this.$emit('scannedCode', this.scanCode)
		},
		close() {
			this.$emit('close')
		},
		purchase() {
			this.close()
			this.$emit('purchase')
		}
	},
}
</script>

<style scoped>
.scanCamera {
	max-height: 30em;
	max-width: 20em;
	margin: 0 auto;
}
</style>